import React, { useEffect, useState } from "react"
import { Button, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux"
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components";
import { fetchFeatureFlag, updateFeatureFlag, removeFeatureFlag } from "../app/actions";
import FeatureFlagTenantsList from "./FeatureFlagTenantsList";
import AddEditFeatureFlagModal from "./AddEditFeatureFlagModal";

const TabContent = styled.div`
    padding-top: 2em;
`

const Summary = styled.div`
    padding: 1em;
    background: #e6e6e6;
    margin-top: 1em;
    margin-bottom: 1em;
    border-radius: 1em;
`

const ButtonBar = styled.div`
    display: flex;
    justify-content: space-between;
`

const InfoLabel = styled.span`
    width: 100px;
    display: inline-block;
    color: darkgrey;
    white-space: nowrap;
`

const RightInfoLabel = styled(InfoLabel)`
    width: 60px;
`

const SummaryHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const FeatureFlagView = ({match, history}) => {
    const id = match.params.id;
    const tab = match.params.tab || "tenants";
    const fetchingFeatureFlag = useSelector(state => state.app.fetchingFeatureFlag)
    const featureFlag = useSelector(state => state.app.featureFlag)
    const dispatch = useDispatch()
    const [showAddEditModal, setShowAddEditModal] = useState(false)

    useEffect(()=>{
        dispatch(fetchFeatureFlag(id))
    }, [])

    const hideAddEditModal = () => {
        setShowAddEditModal(false)
    }

    const handleDelete = (featureFlag) => {
        dispatch(removeFeatureFlag(featureFlag.id))
            .then(()=>{
                setShowAddEditModal(false)
                history.push("/feature-flags/");
            })
    }

    const handleUpdate = (featureFlag) => {
        dispatch(updateFeatureFlag(
            featureFlag.id,
            featureFlag.Active,
            featureFlag.FeatureName,
            featureFlag.FeatureDescription,
            featureFlag.PricePerMonth
        )).then(()=>{
            dispatch(fetchFeatureFlag(featureFlag.id))
            setShowAddEditModal(false)
        })
}
    
    return <div>
        <ButtonBar>
            <Button as={Link} to={"/feature-flags"}>Back To Feature Flags</Button>
            <Button disabled={fetchingFeatureFlag} onClick={() => setShowAddEditModal(true)}>Edit</Button>
        </ButtonBar>
        {fetchingFeatureFlag && <Summary>
            Loading...
        </Summary>}
        {!fetchingFeatureFlag && featureFlag && <Summary>
            <SummaryHeader>
                <h4>
                    Feature Flag #{featureFlag.id}
                </h4>
            </SummaryHeader>
            <div style={{display: "flex", marginTop: "1em"}}>
                <div>
                    <div>
                        <InfoLabel>Name:</InfoLabel> {featureFlag.FeatureName}
                    </div>
                    <div>
                        <InfoLabel>Description:</InfoLabel> {featureFlag.FeatureDescription}
                    </div>
                </div>
                <div style={{marginLeft: "4em"}}>
                    <div>
                        <RightInfoLabel>Active:</RightInfoLabel> {featureFlag.Active === "true" ? "Yes" : "No"}
                    </div>
                    <div>
                        <RightInfoLabel>Price:</RightInfoLabel> {featureFlag.PricePerMonth} kr
                    </div>
                </div>
                <div style={{flex: 1, marginLeft: "4em"}}>
                    <div>
                        <InfoLabel>Updated:</InfoLabel> {featureFlag.updated_at}
                    </div>
                    <div>
                        <InfoLabel>Created:</InfoLabel> {featureFlag.created_at}
                    </div>
                </div>
            </div>
        </Summary>}
        <Nav variant="tabs">
            <Nav.Item>
                <Nav.Link active={tab === "tenants"} as={Link} to={"/feature-flags/" + id + "/tenants"}>
                    Tenants
                </Nav.Link>
            </Nav.Item>
        </Nav>
        {!fetchingFeatureFlag && featureFlag && <TabContent>
            {tab === "tenants" && <div>
                <FeatureFlagTenantsList featureId={featureFlag.id} />
            </div>}
        </TabContent>}
        <AddEditFeatureFlagModal editFeatureFlag={featureFlag} show={showAddEditModal} onHide={hideAddEditModal} onSave={handleUpdate} onDelete={handleDelete}/>
    </div>
}

export default withRouter(FeatureFlagView)